import React, { useState } from 'react';
import { useBackClose } from '../../utils/backStack';

// 게스트 닉네임 변경 (서버 응답은 WebSocket 으로 도착: nickname_changed / nickname_change_error)
export function GuestNicknameModal({ currentName, error, onSubmit, onClose }) {
    useBackClose(true, onClose);
    const [value, setValue] = useState('');
    const [localError, setLocalError] = useState('');
    const submit = () => {
        const v = value.trim();
        if (v.length < 2) return setLocalError('2자 이상 입력하세요.');
        setLocalError('');
        onSubmit(v);
    };
    return (
        <div className="confirm-overlay" onClick={onClose}>
            <div className="confirm-box modal-sm" onClick={e => e.stopPropagation()}>
                <div className="modal-head">
                    <strong>닉네임 변경</strong>
                    <button className="modal-close" onClick={onClose}>✕</button>
                </div>
                <div className="modal-sub">현재 닉네임: <strong>{currentName}</strong></div>
                <input className="modal-input" type="text" placeholder="새 닉네임 (2~10자)" value={value} maxLength={10} autoFocus
                    onChange={e => { setValue(e.target.value); setLocalError(''); }} onKeyDown={e => e.key === 'Enter' && submit()} />
                {(localError || error) && <div className="modal-error">{localError || error}</div>}
                <div className="modal-actions">
                    <button className="btn-primary" onClick={submit}>변경</button>
                    <button className="btn-secondary" onClick={onClose}>취소</button>
                </div>
            </div>
        </div>
    );
}
